module.exports = __webpack_public_path__ + "static/media/README.13368d57.md";